import EventEmitter from './EventEmitter';

class TabControl extends EventEmitter {
  constructor(domElement, options = {}) {
    super();

    this.options = Object.assign({
      unifyTabSizes: true,
    }, options);

    this.domElement = domElement || null;
    this.activePageId = '';
    this.headerLinksDomElements = this.domElement.getElementsByClassName(
      'tabcontrol-header-link');
    this.pageDomElements = this.domElement.getElementsByClassName(
      'tabcontrol-page');

    this.bindEvents();
    if (this.options.unifyTabSizes) {
      this.unifyTabSizes();
    }

    if (this.pageDomElements.length > 0) {
      this.setActivePage(this.pageDomElements[0].id);
    }
  }

  bindEvents() {
    for (let i = 0; i < this.headerLinksDomElements.length; i++) {
      this.headerLinksDomElements[i].addEventListener('click',
        this.onHeaderLinkClick.bind(this));
    }
  }

  unifyTabSizes() {
    setTimeout(() => {
      //const originalPageId = this.activePageId;

      let minHeight = -1;
      let minWidth = -1;
      for (let i = 0; i < this.pageDomElements.length; i++) {
        const pageDomElement = this.pageDomElements[i];
        pageDomElement.classList.add('active');

        const rect = pageDomElement.getBoundingClientRect();

        if (rect.width > minWidth) {
          minWidth = rect.width;
        }

        if (rect.height > minHeight) {
          minHeight = rect.height;
        }

        if (this.activePageId !== this.pageDomElements[i].id) {
          pageDomElement.classList.remove('active');
        }
      }

      for (let i = 0; i < this.pageDomElements.length; i++) {
        this.pageDomElements[i].style.minHeight = minHeight + 'px';
        this.pageDomElements[i].style.minWidth = minWidth + 'px';
      }

    }, 30);
  }

  setActivePage(id) {
    if (this.activePageId === id) {
      return;
    }

    this.activePageId = id;

    for (let i = 0; i < this.headerLinksDomElements.length; i++) {
      this.headerLinksDomElements[i].classList.remove('active');

      if (this.headerLinksDomElements[i].dataset.target === id) {
        this.headerLinksDomElements[i].classList.add('active');
      }
    }

    for (let i = 0; i < this.pageDomElements.length; i++) {
      this.pageDomElements[i].classList.remove('active');

      if (this.pageDomElements[i].id === id) {
        this.pageDomElements[i].classList.add('active');
      }
    }

    this.emit({type: 'tab_change', new_id: this.activePageId});
  }

  getActivePage() {
    return this.activePageId;
  }

  onHeaderLinkClick(e) {
    e.preventDefault();

    const target = e.target.closest('.tabcontrol-header-link');
    if (!target) {
      return;
    }

    const targetId = target.dataset.target || null;
    if (!targetId) {
      return;
    }

    this.setActivePage(targetId);
  }
}

export default TabControl;
